import React from "react";
import { GALLERY } from "@/lib/data";
import { Play } from "lucide-react";

const MediaItem = ({ item, large = false, index }) => {
  const baseClasses =
    "overflow-hidden rounded-xl group relative bg-slate-100 aspect-square " +
    (large ? "col-span-2 row-span-2" : "");

  if (item.type === "video") {
    return (
      <div
        data-testid={`gallery-item-${index}`}
        className={baseClasses}
      >
        <video
          src={item.src}
          poster={item.poster}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/55 backdrop-blur-sm flex items-center justify-center pointer-events-none">
          <Play className="w-4 h-4 text-white fill-white ml-0.5" />
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid={`gallery-item-${index}`}
      className={baseClasses}
    >
      <img
        src={item.src}
        alt={`DT Detail work ${index + 1}`}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      />
    </div>
  );
};

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 lg:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.3em] text-[#4B0082] font-semibold mb-4">
              Our work
            </div>
          </div>
          <p className="text-slate-600 max-w-md text-base leading-relaxed">
            A few looks at the cars we've recently brought back to life.
          </p>
        </div>

        {/* Asymmetric bento gallery: 1 large + 4 small = 5 items */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {GALLERY.map((item, i) => (
            <MediaItem
              key={i}
              item={item}
              index={i}
              large={i === 0}
            />
          ))}
        </div>

        <div className="mt-12 p-6 lg:p-8 border border-slate-200 rounded-xl bg-white flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-[#F3E8FF] flex items-center justify-center flex-shrink-0">
            <Play className="w-5 h-5 text-[#4B0082] fill-[#4B0082] ml-0.5" />
          </div>
          <div>
            <p className="font-heading font-semibold text-slate-900">
              More videos & photos coming soon.
            </p>
            <p className="text-slate-600 text-sm mt-1">
              Follow our progress — fresh transformations posted weekly.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
